module.exports = __webpack_public_path__ + "img/03.b669f9b4.jpg";